export default __webpack_public_path__ + "static/media/special-offer-banner.3dcb5540.png";